module.exports = __webpack_public_path__ + "img/AudiR8.95edf8cd.jpg";